<template>
  <BaseLayout>
    <div class="flex flex-col w-full items-center py-32 gap-5 text-center">
      <div v-if="is404">
        <mdn-heading size="xl" :level="1">404</mdn-heading>
        <mdn-text >Página não encontrada</mdn-text>
      </div>
      <div v-else>
        <mdn-heading size="xl" :level="2">Ops, Ocorreu um erro</mdn-heading>
        <mdn-text v-if="customMessage">{{customMessage}}</mdn-text>
        <mdn-text v-if="errorMessage">{{ errorMessage }}</mdn-text>
      </div>

      <router-link to="/" tag="button">
        <Button global>
          Voltar ao início
        </Button>
      </router-link>
    </div>
  </BaseLayout>
</template>

<script>
import { loadError } from '@/business/error/store'
import { MdnHeading, MdnText, Button } from 'mondrian-vue'
import { clearStorage } from '../business/store'

export default {
  name: 'page-error',
  components: { MdnHeading, MdnText, Button },
  title: ({ is404 }) => is404 ? 'Página não encontrada' : 'Erro',
  props: {
    code: [String, Number],
    customMessage: String
  },
  data: () => ({
    errorMessage: false
  }),
  computed: {
    is404 () {
      return Number(this.code) === 404
    }
  },
  async mounted () {
    await clearStorage(true)

    loadError()
      .then(message => {
        this.errorMessage = message
      })
  }
}
</script>
